import React from 'react'
import { connect } from 'react-redux'
import { Navbar, Nav, NavDropdown, Badge } from 'react-bootstrap'

import ContactInfoModal from './ContactInfoModal'

import { logOutUser } from '../routes/login/reducers/loginReducer'

import {
  userIsStudyCoordinator,
  userIsInvestigator,
  userIsPortalAdmin,
  userIsPharmaVigilance,
  userCanSeeAllRoutes,
  userCanOnlyViewReadOnlyCharts,
} from '../functions/userPermissions'

import useReactPathHash from '../hooks/useReactPathHash'

import './style.css'

const logo = require('../static/images/shionogi_logo_no_text.png')

const TopNavBar = (props) => {

  const { loggedIn, currentUser, unreadNotifications } = props

  const dropdownName = currentUser && currentUser.first_name ? currentUser.first_name : 'User'

  const notificationsBadge = (
    <Badge
      pill
      variant="secondary"
      className={unreadNotifications && unreadNotifications > 0 ? 'notifications-circle' : ''}
    >
      {unreadNotifications || 0}
    </Badge>
  )

  const dropdownTitle = (
    <>
      <span>
        {dropdownName}{' '}
      </span>

      {unreadNotifications && unreadNotifications > 0 ?
        notificationsBadge
        :
        null
      }
    </>
  )

  const locationHash = useReactPathHash()

  return  (
    
    <div className="">
      <Navbar bg="custom-navbar" expand="lg" className="custom-navbar" fixed="top" collapseOnSelect>

        <Nav.Link 
          href="#home" 
          active={locationHash.includes('#/home')} 
          as={Navbar.Brand}
        >
          <img
            src={logo}
            alt="logo"
            width="40"
            height="40"
          /> {' '}
          PROVE Data Entry Portal
        </Nav.Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        {locationHash !== '#/login' ?
          <Navbar.Collapse id="basic-navbar-nav">
            {loggedIn && currentUser ?
              <Nav className="mr-auto">
                {userIsStudyCoordinator(currentUser) || userIsInvestigator(currentUser) || userIsPortalAdmin(currentUser) || userCanSeeAllRoutes(currentUser) || userCanOnlyViewReadOnlyCharts(currentUser) ?
                  <Nav.Link href="#charts" active={locationHash.includes('#/charts')}>
                    Charts
                  </Nav.Link>
                  :
                  null
                }

                {userIsPortalAdmin(currentUser) || userCanSeeAllRoutes(currentUser) || currentUser.can_view_statistics ?
                  <Nav.Link href="#statistics" active={locationHash.includes('#/statistics')}>
                    Statistics
                  </Nav.Link>
                  :
                  null
                }

                {userIsPortalAdmin(currentUser) || userIsPharmaVigilance(currentUser) || userCanSeeAllRoutes(currentUser) ?
                  <Nav.Link href="#adverse-drug-reactions" active={locationHash.includes('#/adverse-drug-reactions')}>
                    Adverse Drug Reactions
                  </Nav.Link>
                  :
                  null
                }

                <Nav.Link href="#instructions" target="_blank" active={locationHash.includes('#/instructions')}>
                  Instructions
                </Nav.Link>

                <ContactInfoModal
                  showModalTrigger={
                    <Nav.Link href="#" active={false}>
                      Contact
                    </Nav.Link>
                  }
                />

                <NavDropdown 
                  title={dropdownTitle} 
                  active={locationHash.includes('#/settings') || locationHash.includes('#/notifications')}
                >
                  <NavDropdown.Item href="#notifications">
                    Notifications {notificationsBadge}
                  </NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Item href="#settings">
                    Settings
                  </NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Item
                    href="#login"
                    onClick={props.logOutUser}
                    active={false}
                  >
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
              :
              null
            }
          </Navbar.Collapse>
          :
          null
        }
      </Navbar>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loggedIn: state.loginReducer.loggedIn,
    currentUser: state.loginReducer.currentUser,
    unreadNotifications: state.notificationsReducer.unreadNotifications,
  }
}

const mapDispatchToProps = {
  logOutUser,
}

export default connect(mapStateToProps, mapDispatchToProps)(TopNavBar)